/*
Author : Raphaël Dardeau


Markup :

<div id="Ads_630" class="ads" data-formatid="630">
    <div id="sas_630"></div>
</div>


Setup :

$(function() {
    $(document).lazyads();
});
*/
;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "lazyads",
        defaults = {
            defaultPageId: "2311/16426",
            //testPageId: "2311/518391",
            callbefore: function() {}
        };

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.setElements();
            this.setVars();
            this.setupSas();
            this.setAds();
            this.setEvents();
        },
        setElements: function() {
            this.settings.callbefore();
            this.ads = $("[data-ads-formatid]").not(".js-ads-is-hidden");
        },
        setVars: function() {
            this.sas_pageid = this.settings.testPageId ? this.settings.testPageId : (sas_pageid) ? sas_pageid : this.settings.defaultPageId;
            this.siteId = this.sas_pageid.split("/")[0];
            this.pageId = this.sas_pageid.split("/")[1];
            if (document.location.hash) {
                this.sas_target = document.location.hash.replace('#','');
                if (sas_target)
                    this.sas_target += ';' + sas_target;
            } else
                this.sas_target = sas_target;
        },
        setupSas: function() {
            sas.setup({
                domain:"http://www.smartadserver.com",
                networkid:84,
                async:true,
                renderMode:0,
                inSequence:true
            });
        },
        callSas: function(formatid) {
            sas.call("std", {
                siteId: this.siteId,
                pageId: this.pageId,
                formatId: formatid,
                target: this.sas_target
            }, {
                onLoad: function() {
                    if ($("#Ads_" + formatid).length && $("#sas_" + formatid).children().length >= 2) {
                        $("#Ads_" + formatid).addClass("is-loaded");
                        if (formatid == 2077 && $("#sas_2077").children("script").length >= 2)
                            $("body").addClass("is-skined");
                    }
                },
                onError: function(e) {
                    sas_blocked = true;
                }
            });
        },
        refreshSas: function(formatid) {
            sas.refresh(formatid);
        },
        setEvents: function() {
            setTimeout($.proxy(function() {
                $(window).on("scroll", $.proxy(function() {
                    this.setAds();
                }, this));
            }, this), 1000);
            $(document).on("tabing-ready tabing-refresh", ".js-tabs-countaspage", $.proxy(function() {
                $(".js-tabs-countaspage .js-tabs-content:hidden div[data-ads-formatid]").each(function (i) {
                    $(this).attr("Ads_id", $(this).attr("id")).removeAttr("id");
                    $(this).children("div").attr("sas_id", $(this).children("div").attr("id")).removeAttr("id");
                    $(this).addClass("js-ads-is-hidden");
                });
                $(".js-tabs-countaspage .js-tabs-content:visible div[data-ads-formatid]").each(function (i) {
                    if ($(this).attr("Ads_id"))
                        $(this).attr("id", $(this).attr("Ads_id")).removeAttr("Ads_id");
                    if ($(this).children("div").attr("sas_id"))
                        $(this).children("div").attr("id", $(this).children("div").attr("sas_id")).removeAttr("sas_id");
                    $(this).removeClass("js-ads-is-hidden").removeData("is-called");
                });

                this.setElements();
                this.setAds({refresh:true});

                $(".js-filters").trigger("filtering");
            }, this));
            $(document).on("filtering", ".js-filters", $.proxy(function() {
                if ($(".js-tabs .js-tabs-content:visible div[data-filters-content]:visible").length < $(".js-tabs .js-tabs-content:visible div[data-filters-content]").length)
                    $(".js-tabs .js-tabs-content:visible div[data-ads-formatid]").hide();
                else
                    $(".js-tabs div[data-ads-formatid]").show();
            }, this));
        },
        setAds: function(options) {
            var options = options || {};
            var _this = this;
            var scrollTop = $(window).scrollTop();
            var windowHeight = $(window).height();
            var formatids = [];
            this.ads.each(function() {
                var formatid = $(this).data("ads-formatid");
                if (options.refresh && $(this).data("is-called")) {
                    _this.refreshSas(formatid);
                } else if (scrollTop + windowHeight >= $(this).offset().top && !$(this).data("is-called")) {
                    formatids.push(formatid);
                    _this.callSas(formatid);
                    $(this).data("is-called", true);
                }
            });
        }
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);
